import getActiveSubscription from '@contentlab/utils/getActiveSubscription';
import {getTokenBalance} from '@contentlab/views/contentlab/pricing/utils';
import contentStudioSubscriptionFetchers from '@/api/fetchers/content-studio/subscription';

export const CREDIT_ACCESS_ACTION = {
  NO_OP: 'NO_OP',
  INSUFFICIENT_CREDITS: 'INSUFFICIENT_CREDITS',
  NO_CREDITS: 'NO_CREDITS',
  EXACT_CREDITS: 'EXACT_CREDITS',
};

export const BLOCKED_CREDIT_STATUSES = [
  CREDIT_ACCESS_ACTION.NO_CREDITS,
  CREDIT_ACCESS_ACTION.INSUFFICIENT_CREDITS,
];

export type CreditAccessAction =
  (typeof CREDIT_ACCESS_ACTION)[keyof typeof CREDIT_ACCESS_ACTION];

/**
 * Resolve the action to take based on the required credits, current subscription balance and subscription plan.
 *  @param requiredCredits
 *  @returns {Promise<CreditAccessAction>} The action to take regarding credit access.
 */
async function resolveCreditAccessAction(
  requiredCredits: number
): Promise<CreditAccessAction> {
  const response = await contentStudioSubscriptionFetchers.current();
  const currentSubscriptions = response.subscriptions;

  const activeSubscription = getActiveSubscription(currentSubscriptions);
  const currentBalance = getTokenBalance(activeSubscription) || 0;

  if (requiredCredits > currentBalance) {
    return currentBalance === 0
      ? CREDIT_ACCESS_ACTION.NO_CREDITS
      : CREDIT_ACCESS_ACTION.INSUFFICIENT_CREDITS;
  }

  return requiredCredits === currentBalance
    ? CREDIT_ACCESS_ACTION.EXACT_CREDITS
    : CREDIT_ACCESS_ACTION.NO_OP;
}

export default resolveCreditAccessAction;
